export const getErrorMsgAsString = (errors = '') => {
  if (typeof errors === 'string') {
    return errors;
  }
  return Object.keys(errors).map(k =>
    errors[k].map(msg => `${msg}`).join('\n')).join('');
};

export const showErrorMsg = (errors) => {
  toastr.options = {
    closeButton: true,
    extendedTimeOut: 0,
    timeOut: 10000,
    positionClass: 'toast-bottom-full-width',
  };

  let errorStr = '';
  if (typeof errors === 'string') {
    errorStr = errors;
  } else {
    errorStr = Object.keys(errors).map(k =>
      errors[k].map(msg => `${msg}<br/>`).join('')).join('');
  }
  toastr.error(errorStr);
};

export const showPermanentErrorMsg = (errors) => {
  toastr.options = {
    tapToDismiss: false,
    onclick: false,
    closeButton: true,
    extendedTimeOut: 0,
    timeOut: 0,
    positionClass: 'toast-bottom-full-width',
  };

  let errorStr = '';
  if (typeof errors === 'string') {
    errorStr = errors;
  } else {
    errorStr = Object.keys(errors).map(k =>
      errors[k].map(msg => `${msg}<br/>`).join('')).join('');
  }
  toastr.error(errorStr);
};



// WEBPACK FOOTER //
// ./src/Common/ErrorMsg.js